module.exports = __webpack_public_path__ + "static/media/icita2008.e3f862b8.png";